
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gold",
      function () {
        return require("private-next-pages/gold/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gold"])
      });
    }
  